import { HtmlHTMLAttributes } from 'react'

import { AmortIcon } from '@/components/icons/amort'
import { HiveIcon } from '@/components/icons/hive'
import { PsychiatryIcon } from '@/components/icons/psychiatry'
import { ConservationType } from '@/enum/conservation-type'

interface ConservationBadgeProps extends HtmlHTMLAttributes<HTMLDivElement> {
  type: ConservationType
}

export function ConservationBadge({ type }: ConservationBadgeProps) {
  const conservationType = {
    [ConservationType.Monitoring]: {
      icon: null,
      label: 'Monitoração',
    },
    [ConservationType.Preservation]: {
      icon: <PsychiatryIcon />,
      label: 'Preservação',
    },
    [ConservationType.Regeneration]: {
      icon: <HiveIcon />,
      label: 'Regeneração',
    },
    [ConservationType.Damping]: {
      icon: <AmortIcon />,
      label: 'Amortecimento',
    },
  }
  const { icon, label } = conservationType[type]

  return (
    <div className="flex cursor-auto items-center gap-2 rounded-xl bg-white/90 px-3 py-2 text-bios-title">
      {icon}
      <span className="text-base font-bold">{label}</span>
    </div>
  )
}
